export * from './parts-view/parts-view.component';
export * from './view/view.component';
